// Core components
import { Component, OnInit } from "@angular/core";

// Third party components
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import * as FileSaver from "file-saver";
import { ToastrService } from 'ngx-toastr';
import { ConfigService } from 'src/app/shared/services/config.service';

// Custom components

@Component({
  selector: 'app-formly-single-file-viewer-type',
  template: `
    <div *ngIf="file">
       <!-- <button class="download-btn-icon" mat-button (click)="onDownload(file)" onclick="this.blur()" mat-stroked-button
         matTooltip="{{ 'common.cta.download' | translate }}">
         <mat-icon fontSet="fal" fontIcon="fa-file-pdf"></mat-icon>
          {{ 'common.cta.download' | translate }}
        </button> -->
        <a href="{{ file.url }}" target="_blank" matTooltip="{{ 'common.cta.open_new_tab' | translate }}">
          {{ file.originalName }}
        </a>
    </div>
    <div *ngIf="!file">
      Nessun file caricato
    </div>
  `,
})

export class SingleFileViewerTypeComponent extends FieldType implements OnInit {
  file: any;

  /**
   * Class constructor
   */
  constructor(
    private configService: ConfigService,
    private translateService: TranslateService,
    private toastrService: ToastrService,
  ) {
    super();
  }

  /**
   * Init component
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    const key = this.field.key as string;
    if (this.model[key]) {
      this.file = this.model[key];
      const path = this.file.path.replace(/src[\\\/]assets/g, 'public');
      let url = "";
      // if (path.substring(0,22) === "https://app.archedi.it") {
      //   url = path;
      // } else {
      //   url = `${this.configService.apiHost}/${path}`;
      // }
      url = `${this.configService.apiHost}/${path}`;
      this.file = {
        ...this.file,
        url,
      }
    }

  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   *
   */
  onDownload(file: any): void {
    FileSaver.saveAs(file.url, file.originalName);
  }
}
